import React, { useState } from 'react'
import { createPortal } from 'react-dom'

import { Button, Footer, H3, Modal, P, TextArea } from '@driftt/tide-core'

const AutomationFeedbackModal = ({ open, onClose, onSubmit }) => {
  const [feedbackText, setFeedbackText] = useState('')

  return createPortal(
    <Modal open={open} size="small" onClose={onClose}>
      <H3>Give feedback</H3>
      <P>Let us know what we can improve or change</P>
      <TextArea
        label="Feedback"
        placeholder="Give us ideas to make this even better"
        value={feedbackText}
        onChange={(e): void => setFeedbackText(e.target.value)}
      />
      <Footer>
        <Button
          type="primary"
          onClick={(): void => onSubmit(feedbackText)}
          disabled={!feedbackText}
        >
          Submit
        </Button>
        <Button type="tertiary" onClick={onClose}>
          Cancel
        </Button>
      </Footer>
    </Modal>,
    document.body
  )
}

export default AutomationFeedbackModal
